module.exports = __webpack_public_path__ + "img/21.fab88c5d.svg";